import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { CONTACT } from "../lib/data";
export const Maintenance = () => {
    const prefix = "//";

    const features = [
        "Regular updates and bug fixes",
        "Performance monitoring and optimization",
        "Security checks and protection",
        "Up to 2 hours of content updates/month",
        "Priority support - within 1 business day."
    ];

    const growthFeatures = [
        "Everything in Maintenance Plan",
        "Monthly SEO report with actionable insights",
        "Google Analytics review and recommendations",
        "1 new page or feature development per quarter",
        "Up to 4 hours of content updates per month"
    ];

    return (
        <section
            id="maintenance"
            data-testid="maintenance-section"
            className="relative py-24 md:py-40 overflow-hidden"
        >
            {/* Background */}
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-cyan-500/10 blur-[140px]" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center"
                >
                    {/* Label */}
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-6">
                        {prefix} Already have a website? Keep it healthy with our maintenance plan.
                    </div>

                    {/* Heading */}
                    <h2 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.9]">
                        Keep your website{" "}
                        <span className="text-gradient-cyan">
                            running smoothly
                        </span>
                    </h2>

                    {/* Subtext */}
                    <p className="mt-8 text-lg md:text-xl text-slate-400 max-w-5xl mx-auto leading-relaxed">
                        Most websites slow down, get hacked, or break quietly — costing you customers without you even knowing. We keep yours fast, secure, and working 24/7 so you never have to worry.
                    </p>
                </motion.div>

                {/* Content */}
                <div className="mt-20 grid lg:grid-cols-2 gap-10 items-center">

                    {/* Features */}
                    {/* <div className="space-y-5">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, x: -10 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                className="flex items-start gap-3 p-4 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:border-cyan-400/40 transition-all"
                            >
                                <CheckCircle
                                    size={20}
                                    className="text-cyan-400 mt-1 shrink-0"
                                />
                                <span className="text-slate-300 text-base leading-relaxed">
                                    {item}
                                </span>
                            </motion.div>
                        ))}
                    </div> */}

                    {/* Pricing Card */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="relative p-8 md:p-10 rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md text-center hover:border-cyan-400/40 transition-all"
                    >
                        {/* Glow */}
                        <div className="absolute inset-0 rounded-3xl bg-cyan-500/5 blur-2xl" />

                        <div className="relative">
                            <div className="text-xl font-semibold text-white">
                                Maintenance Plan
                            </div>

                            <div className="mt-6 text-4xl font-bold text-white">
                                £80
                                <span className="text-lg text-slate-400 font-medium">
                                    /month
                                </span>
                            </div>

                            <div className="mt-2 text-sm text-slate-400">
                                or <b>£750</b>/year (save more)
                            </div>

                            <div className="mt-6 text-sm text-slate-500">
                                Perfect for businesses that want peace of mind and ongoing support.
                                <br />
                                <br />
                                <div className="space-y-5">
                                    {features.map((item, index) => (
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, x: -10 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                            className="flex items-start gap-3 p-4 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:border-cyan-400/40 transition-all"
                                        >
                                            <CheckCircle
                                                size={20}
                                                className="text-cyan-400 mt-1 shrink-0"
                                            />
                                            <span className="text-slate-300 text-base leading-relaxed">
                                                {item}
                                            </span>
                                        </motion.div>
                                    ))}
                                </div>
                            </div>

                            {/* CTA */}
                            <a
                                data-testid="contact-cta-whatsapp"
                                href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
                                    "Hi RS Digital Web Studio, I'd love to talk about a maintenance plan"
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-8 inline-flex items-center justify-center px-6 py-4 rounded-full bg-cyan-400 text-[#040814] font-bold text-base hover:bg-cyan-300 transition-all hover:shadow-xl hover:shadow-cyan-500/30"
                            >

                                Get Maintenance Plan
                            </a>


                            {/* Note */}
                            <div className="mt-4 text-xs text-slate-500">
                                Optional • Cancel anytime
                            </div>
                        </div>

                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="relative p-8 md:p-10 rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md text-center hover:border-cyan-400/40 transition-all"
                    >
                        {/* Glow */}
                        <div className="absolute inset-0 rounded-3xl bg-cyan-500/5 blur-2xl" />

                        <div className="relative">
                            <div className="text-xl font-semibold text-white">
                                Growth Retainer
                            </div>

                            <div className="mt-6 text-4xl font-bold text-white">
                                £150
                                <span className="text-lg text-slate-400 font-medium">
                                    /month
                                </span>
                            </div>

                            <div className="mt-2 text-sm text-slate-400">
                                or <b>£1500</b>/year (save more)
                            </div>

                            <div className="mt-6 text-sm text-slate-500">
                                Perfect for businesses that want peace of mind and ongoing support.
                                <br />
                                <br />
                                <div className="space-y-5">
                                    {growthFeatures.map((item, index) => (
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, x: -10 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                            className="flex items-start gap-3 p-4 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:border-cyan-400/40 transition-all"
                                        >
                                            <CheckCircle
                                                size={20}
                                                className="text-cyan-400 mt-1 shrink-0"
                                            />
                                            <span className="text-slate-300 text-base leading-relaxed">
                                                {item}
                                            </span>
                                        </motion.div>
                                    ))}
                                </div>
                            </div>

                            {/* CTA */}
                            <a
                                data-testid="contact-cta-whatsapp"
                                href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
                                    "Hi RS Digital Web Studio, I'd love to talk about a Growth Retainer plan"
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-8 inline-flex items-center justify-center px-6 py-4 rounded-full bg-cyan-400 text-[#040814] font-bold text-base hover:bg-cyan-300 transition-all hover:shadow-xl hover:shadow-cyan-500/30"
                            >

                                Get Growth Retainer
                            </a>


                            {/* Note */}
                            <div className="mt-4 text-xs text-slate-500">
                                Optional • Cancel anytime
                            </div>
                        </div>

                    </motion.div>
                </div>
            </div>
        </section>
    );
};